import React, { useEffect } from "react";

import { Fancybox as NativeFancybox } from "@fancyapps/ui/dist/fancybox.esm.js";
import "@fancyapps/ui/dist/fancybox.css";

export const Fancybox = (props) => {
    const delegate = props.delegate || "[data-fancybox]";

    useEffect(() => {
        NativeFancybox.bind(delegate, {
            Toolbar: {
                display: [
                    { id: "zoom", position: "left" },
                    { id: "counter", position: "center" },
                    { id: "close", position: "right" },
                ],
            },
            Thumbs: {
                autoStart: false,
            },
            infinite: false,
            Hash: false
        });

        return () => {
            NativeFancybox.destroy();
        };
    }, []);

    return (
        <>
            {props.children}
        </>
    )
}